export default __webpack_public_path__ + "static/media/dj.e94751c5.svg";